import { render, staticRenderFns } from "./TestCaseChart.vue?vue&type=template&id=44760c23&scoped=true&"
import script from "./TestCaseChart.vue?vue&type=script&lang=js&"
export * from "./TestCaseChart.vue?vue&type=script&lang=js&"
import style0 from "./TestCaseChart.vue?vue&type=style&index=0&id=44760c23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44760c23",
  null
  
)

export default component.exports